<script lang="ts">
  import { page } from "$app/state";
  import { goto } from "$app/navigation";
  import { lang } from "$store/lang";
  import { theme, toggleTheme } from "$store/theme";
  import { localizeHref } from "$lib/services/i18n";
  import Logo from "./Logo.svelte";

  let {
    links = [] as Array<{
      href: string;
      labelDe?: string;
      labelEn?: string;
      label?: string;
      cta?: boolean;
    }>
  } = $props();

  let menuOpen = $state(false);
  let currentLang = $state("de");

  $effect(() => {
    currentLang = $lang;
  });

  function toggleLang(l: string) {
    lang.set(l);
    // Strip any existing /en prefix first so repeated clicks don't stack it (/en/en).
    const basePath = page.url.pathname.replace(/\/$/, "").replace(/^\/en(?=\/|$)/, "");
    if (l === "en") {
      goto("/en" + basePath);
    } else {
      goto(basePath || "/");
    }
  }

  function closeOnOutsideClick(e: MouseEvent) {
    const target = e.target as HTMLElement;
    if (!target.closest(".site-header")) {
      menuOpen = false;
    }
  }
</script>

<svelte:window onclick={closeOnOutsideClick} />

<header class="site-header">
  <div class="container">
    <a href={localizeHref("/", currentLang)} class="logo">
      <Logo /><span class="sr-only">Logo</span>
    </a>
    <nav id="nav-main" class="nav-main" class:open={menuOpen}>
      {#each links as link}
        <a href={localizeHref(link.href, currentLang)} class:nav-cta={link.cta} onclick={() => (menuOpen = false)} aria-current={page.url.pathname === (currentLang === "en" ? "/en" + link.href : link.href) ? "page" : undefined}>
          <span lang="de">{link.labelDe || link.label}</span>
          <span lang="en">{link.labelEn || link.label}</span>
        </a>
      {/each}
    </nav>
    {#if !page.data?.deOnly}
      <div class="lang-toggle" role="group" aria-label="Sprache wählen / Select language">
        <button data-lang="de" class:active={currentLang === "de"} aria-label="Auf Deutsch umschalten" aria-pressed={currentLang === "de"} onclick={() => toggleLang("de")}>DE</button>
        <button data-lang="en" class:active={currentLang === "en"} aria-label="Switch to English" aria-pressed={currentLang === "en"} onclick={() => toggleLang("en")}>EN</button>
      </div>
    {/if}
    <button class="dark-toggle" onclick={toggleTheme} aria-label={$theme === "dark" ? "Helles Design aktivieren / Switch to light mode" : "Dunkles Design aktivieren / Switch to dark mode"} aria-pressed={$theme === "dark"}>
      {#if $theme === "dark"}
        <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" /></svg>
      {:else}
        <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><circle cx="12" cy="12" r="5" /><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" /></svg>
      {/if}
    </button>
    <button class="nav-toggle" class:open={menuOpen} onclick={() => (menuOpen = !menuOpen)} aria-label="Menü" aria-expanded={menuOpen} aria-controls="nav-main">
      <span></span><span></span><span></span>
    </button>
  </div>
</header>

<style>
  .logo {
    height: 40px;
    width: 182px;
  }
</style>
